import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AlphaFilter } from '@pixi/filter-alpha';
import { Container } from '@pixi/react';
import { useAppSelector } from '../../../../redux/store';
import { isTestEnvironment, range } from '../../../../utils/utils';
import { RabbitCommunityCardDisplay } from './rabbitCommunityCardDisplay';
const RABBIT_FILTERS = [new AlphaFilter(0.25)];
export const RabbitCommunityCardsContainer = ({ x, y, allCardRenderProperties }) => {
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const numCommunityCards = useAppSelector((state) => state.poker.communityCards.length);
    const numRabbits = useAppSelector((state) => state.poker.rabbits.length);
    if (!isPowerPlayer || numRabbits === 0) {
        return null;
    }
    const pixiData = isTestEnvironment() ? { type: 'rabbits', numCards: numRabbits } : null;
    return (_jsx(Container, { "pixi-data": pixiData, x: x, y: y, filters: RABBIT_FILTERS, children: range(numRabbits).map((i) => {
            // rabbit index needs to be offset by the number of "live" community cards to get the right cardRenderProperties:
            const cardRenderProperties = allCardRenderProperties[numCommunityCards + i];
            return cardRenderProperties ? (_jsx(RabbitCommunityCardDisplay, { rabbitIndex: i, cardRenderProperties: cardRenderProperties }, i)) : null;
        }) }));
};
